import React from 'react';
import FacebookShare from 'src/components/FacebookShare/FacebookShare';

import { FormattedMessage } from 'react-intl';
import DesktopPrompt from 'src/components/SharePopup/DesktopSharePopup';
import DonateButton from '../Page/DonateButton';
import { AnalyticsClick } from 'src/redux/modules/analytics';

interface Props {
  ownerName: string;
  pageName: string;
  analitycsClick: AnalyticsClick;
}

const DesktopEncourageShareAndDonate: React.StatelessComponent<Props> = ({
  ownerName,
  pageName,
  analitycsClick,
}) => (
  <DesktopPrompt>
    <>
      <h1>
        <FormattedMessage
          id="DesktopEncourageShareAndDonate.title"
          defaultMessage="Plenty of ways to support a good cause"
        />
      </h1>

      <p className="jg-space-mbmd">
        <FormattedMessage
          id="DesktopEncourageShareAndDonate.didYouKnow"
          defaultMessage="You can support {ownerName}’s cause by donating today or you can help reach more supporters by sharing with your friends."
          values={{
            ownerName,
          }}
        />
      </p>
      <div className="jg-space-mbsm">
        <DonateButton
          isActive
          name={pageName}
          pageSection="page > donate prompt"
          donate={page => {
            analitycsClick({
              event: 'link click',
              eventValue: 'donate',
              pageSection: 'page > donate prompt',
              subtype: 'button',
            });
          }}
        />
      </div>

      <FacebookShare
        buttonText="Share to Facebook"
        location="page > donate prompt"
        className="jg-space-mbmd"
      />
    </>
  </DesktopPrompt>
);

export default DesktopEncourageShareAndDonate;



// WEBPACK FOOTER //
// ./src/components/EncourageShareAndDonate/DesktopEncourageShareAndDonate.tsx